import * as React from "react";
import {  TextInput, SelectInput, NumberInput, DateTimeInput, ReferenceInput, AutocompleteInput, required } from "react-admin";
import { Grid } from "@mui/material";
import {
  StockTypeEnum, SupplierTypeEnum
} from "../../common/enum";
import Transformer from "../../common/Transformer";
import { StockEditComponent } from "./StockComponent";
import { Edit, SimpleForm} from "src/enterprise/ra-rbac";

export const StockEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt", "isLatest"],
      update: {
        product: data.product.id,
      },
    });
    return data;
  };

  const filterToQuery = (searchText) => ({
    "search": searchText
  });

  return (
    <Edit
      component={StockEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid container item rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} md={6}>
              <TextInput disabled source="id" />
            </Grid>
          </Grid>
          <Grid item sm={12} md={6}>
            <ReferenceInput
              source="product.id"
              reference="admin/products"
            >
              <AutocompleteInput
                filterToQuery={(e) => filterToQuery(e)}
                optionText={(record) => record.name+" "+record.sku}
                size="small"
                label="Product"
              />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} md={6}>
            <NumberInput
              validate={required()}
              source="quantity"
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <TextInput source="warehouse" />
          </Grid>
          <Grid item sm={12} md={4}>
            <SelectInput
              validate={required()}
              source="type"
              choices={StockTypeEnum}
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <SelectInput
              validate={required()}
              source="supplier"
              choices={SupplierTypeEnum}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <DateTimeInput disabled source="created_at"/>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
